import initializeWizardCommon from './initializewizardcommon.js';
import {onDOMContentLoaded} from '../../dom/events.js';
import recipientForm from './recipientform.js';

onDOMContentLoaded(function() {
    initializeWizardCommon();
    recipientForm();
});
